import { Checkbox, FormControl, FormErrorMessage, FormHelperText, FormLabel } from "@chakra-ui/react";
import { translate } from "../../../i18n";
import { typography } from 'theme/tokens';

type Props = {
    isGameAvailable: boolean;
    setIsGameAvailable: (newValue: boolean) => void;
    isCoachingAvailable: boolean;
    setIsCoachingAvailable: (newValue: boolean) => void;
}

export default function CourtAvailabilityTypePicker({ isGameAvailable, setIsGameAvailable, isCoachingAvailable, setIsCoachingAvailable }: Props) {
    return (
        <>
            <FormControl isInvalid={!isGameAvailable && !isCoachingAvailable}>
                <FormLabel {...typography.formLabel}>{translate('courts.court_availability_type_picker.title')}</FormLabel>
                <FormErrorMessage>{translate('courts.court_availability_type_picker.error_message')}</FormErrorMessage>
                <FormHelperText>{translate('courts.court_availability_type_picker.helper_text')}</FormHelperText>
                <Checkbox
                    isChecked={isGameAvailable}
                    onChange={(event) => setIsGameAvailable(event.target.checked)}
                >
                    {translate('courts.court_availability_type_picker.is_game_available')}
                </Checkbox>
                <Checkbox
                    marginLeft={8}
                    isChecked={isCoachingAvailable}
                    onChange={(event) => setIsCoachingAvailable(event.target.checked)}
                >
                    {translate('courts.court_availability_type_picker.is_coaching_available')}
                </Checkbox>
            </FormControl>
        </>
    );
}
